module.exports = __webpack_public_path__ + "static/media/AntonKammermeier.b81716ad.jpg";